import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/PageHeader";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { OrdersTab } from "@/components/wholesale/OrdersTab";
import { HospitalsTab } from "@/components/wholesale/HospitalsTab";
import { ReceiptsTab } from "@/components/wholesale/ReceiptsTab";
import { DiscrepanciesTab } from "@/components/wholesale/DiscrepanciesTab";

export default function Wholesale() {
  const { can } = useAuth();
  const [hospitals, setHospitals] = useState([]);
  const [tab, setTab] = useState("orders");
  const [openId, setOpenId] = useState(null);
  const loadHospitals = () => api.get("/wholesale/hospitals").then((r) => setHospitals(r.data)).catch(() => setHospitals([]));
  useEffect(() => { loadHospitals(); }, []);

  return (
    <div>
      <PageHeader title="Partner Supply" subtitle="Cost-price supply to Hospital Partners against approved allocations — for internal visibility, no billing" />
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList data-testid="wholesale-tabs">
          <TabsTrigger value="orders" data-testid="ws-tab-orders">Supply orders</TabsTrigger>
          <TabsTrigger value="hospitals" data-testid="ws-tab-hospitals">Hospital Partners</TabsTrigger>
          <TabsTrigger value="discrepancies" data-testid="ws-tab-discrepancies">Discrepancy log</TabsTrigger>
          <TabsTrigger value="receipts" data-testid="ws-tab-receipts">Supplier receipts</TabsTrigger>
        </TabsList>
        <TabsContent value="orders"><OrdersTab hospitals={hospitals} onChanged={loadHospitals} can={can} openId={openId} setOpenId={setOpenId} /></TabsContent>
        <TabsContent value="discrepancies"><DiscrepanciesTab onOpen={(id) => { setTab("orders"); setOpenId(id); }} /></TabsContent>
        <TabsContent value="hospitals"><HospitalsTab hospitals={hospitals} reload={loadHospitals} can={can} /></TabsContent>
        <TabsContent value="receipts"><ReceiptsTab /></TabsContent>
      </Tabs>
    </div>
  );
}
